export default __webpack_public_path__ + "static/media/Go-Fully-Digital-With-DDD.6ba251ae.png";